import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const animationName = 'loading-skeleton';
const SkeletonSpan = styled.span.withConfig({
  displayName: "SingleSkeletonLoader__SkeletonSpan"
})(({
  height,
  width,
  shape,
  theme
}) => ({
  height: typeof height === 'number' ? `${height}px` : height,
  width: typeof width === 'number' ? `${width}px` : width,
  borderRadius: shape === 'circle' ? '50%' : '0.25rem',
  overflow: 'hidden',
  position: 'relative',
  userSelect: 'none',
  zIndex: 1 /* Necessary for overflow: hidden to work correctly in Safari */,

  background: theme.color['fill-tertiary-hover'],
  backgroundImage: `linear-gradient(
      to right,
      ${theme.color['fill-tertiary-hover']},
      ${theme.color['fill-tertiary-default']} 20%,
      ${theme.color['fill-tertiary-hover']} 40%
    )`,
  backgroundSize: '200%',
  backgroundRepeat: 'no-repeat',
  animationName,
  animationDelay: '0s',
  animationDuration: '2s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
  [`@keyframes ${animationName}`]: {
    '0%': {
      backgroundPositionX: '100%'
    },
    '100%': {
      backgroundPositionX: '-100%'
    }
  },
  [`@media (prefers-reduced-motion)`]: {
    display: 'none'
  }
}));
export const SingleSkeletonLoader = ({
  height,
  width = '100%',
  shape = 'rect',
  circleSize,
  wrapperWidth = '100%',
  marginStyle,
  display,
  'data-test-id': dataTestId = 'skeleton-loading'
}) => {
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    inlineSize: wrapperWidth
  }, marginStyle, {
    display: display,
    children: /*#__PURE__*/_jsx(SkeletonSpan, {
      "aria-busy": true,
      role: "status",
      height: shape === 'circle' ? circleSize : height,
      width: shape === 'circle' ? circleSize : width,
      shape: shape,
      "data-test-id": dataTestId
    })
  }));
};